import { render, staticRenderFns } from "./InputMail.vue?vue&type=template&id=5c8f38b0&"
import script from "./InputMail.vue?vue&type=script&lang=js&"
export * from "./InputMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/production/spf-sexosafe-ezplatform/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c8f38b0')) {
      api.createRecord('5c8f38b0', component.options)
    } else {
      api.reload('5c8f38b0', component.options)
    }
    module.hot.accept("./InputMail.vue?vue&type=template&id=5c8f38b0&", function () {
      api.rerender('5c8f38b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/TestForm/components/InputMail/InputMail.vue"
export default component.exports